import _objectSpread from "C:/Users/amirs/Documents/Projects/top-menu-panel/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
//
//
//
//
//
//
import { mapGetters } from "vuex";
import TablesList from "./list/TablesList.vue";
export default {
  name: "Tables.vue",
  components: {
    TablesList: TablesList
  },
  computed: _objectSpread({}, mapGetters({
    currentProvider: "profile/currentProvider"
  }))
};